import React from 'react';

interface InstantlyIconProps {
  height?: number;
  className?: string;
}

export const InstantlyLogo: React.FC<InstantlyIconProps> = ({
  height = 26,
  className,
}) => {
  return (
    <svg
      height={height}
      width={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_instantly_icon)">
        <path
          d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
          fill="#0081FF"
        />
        <path
          d="M11.5214 18.3125H7.27313C7.12373 18.3125 7.02983 18.151 7.10411 18.0212L13.9093 6.12891H23.8678C24.0293 6.12891 24.1207 6.3142 24.0218 6.44231L19.1563 12.753C19.0578 12.8811 19.1488 13.0664 19.3103 13.0664H24.5063C24.6816 13.0664 24.7675 13.2797 24.6411 13.4011L9.8388 27.6479C9.69816 27.7832 9.46822 27.6505 9.51496 27.461L11.7105 18.5533C11.7405 18.431 11.6479 18.3125 11.5214 18.3125Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_instantly_icon">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
